<template>
     <div class="publicViewClass" style="padding-top:0">
         <div class="edit-step">
            <topicSteps :active = "2" :propList="propList"></topicSteps>
        </div>
         <div id="editPaper" class="app-inner">
             <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            上一步
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="openThree"
            >
             下一步
           </el-button>
            </div>
            <div class="edit-from">
                 <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  关联试卷-{{list.paperName}}
            </div>
        </div>
        <div class="edit-from-list">
            <div class="edit-from-list-check flex align-cen">
                <div class="label">试题设置：</div>
                 <el-checkbox-group v-model="checkList">
                <el-checkbox label="1">试题乱序</el-checkbox>
                <el-checkbox label="2">试题选项随机</el-checkbox>
            </el-checkbox-group>
            </div>
             <div class="edit-from-list-check flex align-cen" style="padding-top:30px">
                <div class="label isRequild">添加试题：</div>
                <div class="addpaper"  v-if="!nullQueLen" @click="nullQueLen = true">添加试题</div>
                 <div class="addpaper"  v-if="!isTopicList" @click="isTopicList = true">取消选择</div>
             </div>
        </div>
        <el-tabs type="border-card" v-model="activeIndex" @tab-click="handleTabStep" v-if="!isTopicList && nullQueLen">
            <el-tab-pane  name="1">
                 <span slot="label"><i class="icon-al-info-circle"></i> 从题库随机选择试题</span>
                 <div class="checkPaper">
                    <div class="tab-content f-h-flex1" v-if="checkTopicClass">
                        <div class="questions-select-tip">
                            <h4>已选择的分类</h4>
                            <div class="qts-counts-tip">
                                <span class="question-count">将从 <b>{{questionType.length}}</b> 个题型选择 <b>{{allNum}}</b> 道试题.</span>
                                <span class="grayTip">（已在试卷的题不会再显示在分类列表中）</span>
                            </div>
                            <div class="at-sel-qs-cs-ls">
                                <div class="at-sel-qs-cs-ls-item flex align-cen" v-for="(item, index) in questionType" :key="index">
                                    <span style="margin-right: 13px;" class="flex align-cen">
                                        <!-- <i class="icon-al-delete-fill icon-delet" @click="deletPro(item)"></i> -->
                                        <i class="icon-folder"></i>
                                    </span>
                                    <span class="qts-cate-name">
                                       {{$util.getTopicType(item.type)}}
                                        <span style="color:#999">({{item.value}} 道试题)</span>
                                    </span>
                                    <span>抽选</span>
                                    <span class="qts-count first">
                                        <input type="number"
                                         min="1"
                                         :max="item.value" style="width:80px" 
                                         v-model="item.subQuestionNum"
                                         class="form-control"
                                         @input="handleInputChange(index,1,item)"
                                         >
                                    </span>
                                    <span>道试题</span>
                                    <span class="qts-score" style="padding-left:28px">每题 </span>
                                    <input type="number" min="0"  style="width:80px" v-model="item.point" class="form-control"
                                     @input="handleInputChange(index,2,item)"
                                    >
                                    <span>分</span>
                                </div>
                                <div class="public-btn-small flex align-cen " style="padding-left:0;padding-top:20px">
                                        <div class="public-btn-small-plan"  style="margin-left:0" @click="openTopicClass">
                                        选择分类
                                        </div>
                                    <el-button type="primary"  class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
                                    @click="radomSub"
                                        >
                                       确定
                                    </el-button>
                                        </div>
                            </div>
                        </div>
                    </div>
                    <div class="no-category" v-if="!checkTopicClass && !isTopicList">
                        <img src="../../../../assets/images/no_question_tips.png" alt="">
                        <div class="text">
                            点击 <span @click="openTopicClass">"选择分类"</span> 按钮打开分类窗口选择分类，然后输入选择试题数目
                        </div>
                        <div class="yks-blue" @click="openTopicClass">选择分类</div>
                    </div>
                 </div>
            </el-tab-pane>
            <el-tab-pane name="2">
                <span slot="label"><i class="icon-al-file-plus"></i> 手动从题库选择试题</span>
                  <div class="checkPaper">
                    <div class="f-h-flex2">
                  <div class="categories-tree">
                    <div class="tree-search">
                        <el-input v-model="searchName" placeholder="搜索分类"></el-input>
                        <span class="icon-al-search" @click="getClass"></span>
                    </div>
                    <div class="categories-tree-item">
                        <div class="jstree-node flex align-cen" 
                        :class="-1 == textActive  ? 'treeactive': ''"
                        @click="swichTopic('',-1)"
                        >
                            <i class="jstree-icon"></i>
                            <span>所有分类</span>
                        </div>
                        <div class="jstree-node flex align-cen" v-for="(item,index) in options" :key="item.id"
                        :class="index == textActive  ? 'treeactive': ''"
                        @click="swichTopic(item.id,index)"
                        >
                         <i class="jstree-icon"></i>
                          <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                            <span class="publictitline1">{{item.name}}</span>
                          </el-tooltip>
                        </div>
                    </div>
                    </div>
                    <div class="categories-panel-dragger"></div>
                    <div class="questions-panel grow">
                        <div class="grow-top">
                            <div class="fillter  flex align-cen">
                               <el-checkbox  v-model="checkAll1" @change="handleCheckAllChange1">全选</el-checkbox>
                                <div class="regulaOption">
                                    <el-select v-model="regulaTagValue"  clearable placeholder="任意标签"
                                    @change="swichTopic(swichId,swichIndex)"
                                    >
                                        <el-option
                                        v-for="item in regulaTag"
                                        :key="item"
                                        :label="item"
                                        :value="item"> 
                                        </el-option>
                                    </el-select>
                                </div>
                                  <div class="regulaOption">
                                    <el-select v-model="regulaTypesValue" clearable placeholder="任意题型"
                                      @change="swichTopic(swichId,swichIndex)"
                                    >
                                        <el-option
                                        v-for="item in regulaTypes"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            <div class="grow-bot flex mft">
                           <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                           <div class="mft grow-bot-btn" @click="regulaSub(1)">
                            确定选择
                           </div>
                        </div>
                            </div>
                        </div>
                        <div class="grow-cen-item">
                             <el-checkbox-group v-model="errorDataChecked" @change="handleCheckedCitiesChange1">
                          <el-checkbox v-for="(item,index) in swichList" :label="item.id" :key="item.id">
                        <div class="topic-item">
                           <div class="ques-title flex">
                                <span class="ques-number">{{index +1}}/{{totalCount}}</span>
                                <span class="ques-type">{{$util.getTopicType(item.type)}}</span>
                                <span v-html="item.title" style="max-width:70%" :class="item.type == 9 ? 'clozeClass' : ''"></span> 
                                 <AudioTem :audioSrc="item.audio" v-if="item.audio"></AudioTem>
                                 <span class="mft" style="padding-right:20px;width:80px;color:red;padding-left:20px;font-size:18px">{{item.score}}分</span>
                            </div> 
                            <!-- 试题详情 -->
                                <!-- 试题详情 -->
                            <div class="question-option-list" v-if="item.isTrue">
                                 <ol v-if="item.type !=4">
                                <li v-for="(sonitem,sonIndex) in item.answerList">
                                    <p v-html="sonitem.content"></p>
                                </li>
                            </ol>
                    <div class="test_result">
                        <div class="rightAnswer flex">
                            <span v-if="item.type !=4">
                                正确答案：
                                <span v-for="(sonitem,sonIndex) in item.answerList">
                                    <strong  v-if="sonitem.isRight == 1">
                                    {{Eng[sonIndex]}}
                                </strong>
                                </span> 
                            </span>
                            <span v-if="item.type ==4">
                                 正确答案：
                                <span v-for="(sonitem,sonIndex) in item.answerList">
                                    <strong  v-if="sonitem.isRight == 1">
                                    {{sonitem.content}}<span v-if="sonIndex !=item.answerList.length - 1">，</span>
                                </strong>
                                </span>
                               </span>
                        </div>
                         <div class="jx flex align-cen">
                            题目解析： <span v-html="item.analysis || '暂无解析'" style="max-width: 80%;line-height:30px"></span>
                         </div>
                    </div>
                            </div>
                            <div class="ques-answers">
                                <div class="ques-answers-class flex align-cen">
                                    <span class="label other">分类：</span>
                                    <span class="labels">{{item.classifyName}}</span>
                                </div>
                            </div>
                        </div>
                     </el-checkbox>

                             </el-checkbox-group>
                        </div>
                    </div>
                    </div>
                  </div>
            </el-tab-pane>
            <el-tab-pane name="3">
                <span slot="label"><i class="icon-al-plus-circle"></i> 新增试题</span>
                <div class="checkPaper">
                    <topicTemplate
                    :PropType="'paper'"
                    ref="topicTemplate"
                    @sendStatus="addToticEmit"
                    ></topicTemplate>
                </div>
            </el-tab-pane>
            <el-tab-pane name="4">
                 <span slot="label"><i class="icon-al-upload"></i> 导入word或Excel</span>
                  <div class="checkPaper checkPaper4">
                    <importemplate
                    :PropType="'paper'"
                    ref="importTemplate"
                     @sendStatus="importToticEmit"
                     v-if="isStep"
                    ></importemplate>
                    <twoImportemplate
                    :twoPropType="'paper'"
                    :twoPropData="encryptQuery"
                    ref="twoImportemplate"
                     @sendStatus="twoimportToticEmit"
                      @sendStatus1="cacelIM"
                     v-if="!isStep"
                    ></twoImportemplate>
                </div>
            </el-tab-pane>
            </el-tabs>
            <!-- 最终确定试题列表 -->
            <div class="topicList flex" v-if="isTopicList">
                <div class="topicList-left">
                     <div class="topEditBtn flex align-cen">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-tooltip class="item" effect="dark" content="添加试题" placement="top">
                     <i class="icon-al-fileplus-fill" @click="addSt"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除试题" placement="top">
                     <i class="icon-al-delete-fill" @click="deletTopic(0)"></i>
                    </el-tooltip>
                     <el-tooltip class="item" effect="dark" content="试题查重" placement="top">
                     <i class="icon-al-search-plus" @click="repeatPaper"></i>
                    </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="修改分数" placement="top">
                     <i class="icon-al-edit" @click="ediScore"></i>
                    </el-tooltip>
                             <el-select
                            v-model="txmodal"
                            placeholder="请选择"
                            @change="txSelect"
                            style="margin-left:10px"
                        >
                            <el-option
                            v-for="item in txtype"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                            >
                            </el-option>
                        </el-select>
                </div>
                 <div style="margin: 15px 0;"></div>
                   <el-checkbox-group v-model="checkedTopic" @change="handleCheckedCitiesChange" class="sortable-chapter">
                     <el-checkbox v-for="(item,index) in TopicPage" :label="item" :key="item.id"
                     :class="{ 'commonClass': item.classAdded }"
                     class="childrenlist"
                     >
                         <div class="handle_move" @click.prevent>
                                    <i  class="icon-al-arrows-alt"  style="font-size:30px"/>
                                    </div>
                        <div class="topic-item" >
                           <div class="ques-title flex">
                                <span class="ques-number">{{index +1}}/{{TopicPage.length}}</span>
                                <span class="ques-type">{{$util.getTopicType(item.type)}}</span>
                                <span v-html="item.title" style="max-width:70%" :class="item.type == 9 ? 'clozeClass' : ''"></span>
                                 <AudioTem :audioSrc="item.audio" v-if="item.audio"></AudioTem>
                                <span class="mft" style="padding-right:50px">{{item.score}}分</span>
                                <div class="stcz2 pustclass" style="color:#36aafd;cursor: pointer;"  @click.prevent="openTopicRe(item.isTrue,index,2,item)">
                                {{item.isTrue ? '收回' : '展开' }}
                           </div>
                            </div> 
                            <!-- 试题详情 -->
                            <div class="question-option-list" v-if="item.isTrue">
                                 <ol v-if="item.type != 9 && item.type != 5">
                                <li v-for="(sonitem,sonIndex) in item.answerList">
                                    <p v-html="sonitem.content"></p>
                                </li>
                            </ol>
                            <div class="refAnswer" style="margin-left:-25px" v-if="item.type == 5">
                        <div class="detailKeyWorld" v-if="item.rule">
                           <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                            <p>关键字：</p>
                             <p v-for="(sonitem,sonIndex) in item.answerList">
                                {{sonitem.content}}<span v-if="sonIndex !=item.answerList.length-1">，</span>
                            </p>
                           </div>
                        </div>
                        <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                    </div>
                    <div class="clzoe" v-if="item.type == 9">
                     <div class="clzoeItem" v-for="(sonitem,sonIndex) in item.answerList" :key="sonIndex">
                        <p class="cloze-op-p">
                           <strong> {{sonIndex + 1}}:</strong>
                        </p>
                        <ol style="margin-left:20px">
                            <li  v-for="(sonitem1,sonIndex1) in item.answerList[sonIndex].clozeList" :key="sonIndex1">
                                <p v-html="sonitem1.content"></p>
                            </li>
                        </ol>
                     </div>
                   </div>
                    <div class="test_result">
                        <div class="rightAnswer flex">
                             <span v-if="item.type !=4 && item.type != 7 && item.type != 9 && item.type != 5">
                                正确答案：
                                <span v-for="(sonitem,sonIndex) in item.answerList">
                                    <strong  v-if="sonitem.isRight == 1">
                                    {{Eng[sonIndex]}}
                                </strong>
                                </span>
                            </span>
                               <span v-if="item.type == 5" class="flex align-cen" style="color:#009aff">
                                参考答案：
                                <span v-html="item.refAnswer"></span>
                            </span>
                                <span v-if="item.type == 7">
                                正确顺序：
                                <span v-for="(sonitem,sonIndex) in sortedIndexes">
                                    <span>
                                    {{Eng[sonitem]}}
                                </span>
                                </span>
                            </span>
                             <span v-if="item.type == 9">
                    正确顺序：
                    <span v-for="(sonitem,sonIndex) in item.answerList">
                                <span style="margin-right:20px">
                                {{sonIndex + 1}}:
                                <span v-for="(sonitem1,sonIndex1) in item.answerList[sonIndex].clozeList" :key="sonIndex1">
                                    <span v-if="sonitem1.isRight == 1">{{Eng[sonIndex1]}}</span>
                                </span>
                                </span>
                    </span>
                </span>
                            <span v-if="item.type ==4">
                                 正确答案：
                                <span v-for="(sonitem,sonIndex) in item.answerList">
                                    <strong  v-if="sonitem.isRight == 1">
                                    {{sonitem.content}}<span v-if="sonIndex !=item.answerList.length - 1">，</span>
                                </strong>
                                </span>
                               </span>
                        </div>
                         <div class="jx">
                           题目解析：<span v-html="item.analysis || '暂无解析'" style="max-width: 80%;line-height:30px"></span>
                         </div>
                    </div>
                            </div>
                            <div class="ques-answers">
                                <div class="ques-answers-class flex align-cen">
                                    <span class="label other">分类：</span>
                                    <span class="labels">{{item.classifyName}}</span>
                                </div>
                                <div class="ques-answers-edit flex align-cen">
                                <div class="edit-question" @click.prevent="openEditTopic(item)">编辑</div>
                                <div class="control-line"></div>
                                <div class="edit-question" @click.prevent="deletTopic(item.id)">删除</div>
                                 <!-- <div class="control-line"></div> -->
                                 <!-- <div class="edit-question" @click.prevent="deletTopic(item.id)" style="color:#999">删除且从题库中也删除</div> -->
                                </div>
                            </div>
                        </div>
                     </el-checkbox>
                   </el-checkbox-group>
                </div>
                <div class="topicList-right mft">
                     <div class="addpaper">题型分析</div>
                      <div class="exam-pr-pie">
                            <PieChart :option="PieChartOption" :pieID="2" :isreload='1'></PieChart>
                        </div>
                       <div class="addpaper">题量分析</div>
                       <div class="exam-pr-list">
                            <div class="item-colmn" v-for="(item,index) in srdata">
                                <div class="item-colmn-top">
                                    {{item.name}} <span style="color:#36aafd">（{{item.value}}%）</span>
                                </div>
                                <div class="item-colmn-bot flex align-cen">
                                    <div class="bot-progess">
                                        <div class="bot-progess-n"
                                        :style="{
                                        width: item.value + '%',
                                        backgroundColor: colors[index % colors.length]
                                        }"
                                        ></div>
                                    </div>
                                    <div class="bot-num mft">{{item.num}}题</div>
                                </div>
                            </div>
                       </div>
                       <div class="addpaper">难度分析</div>
                         <div class="exam-pr-pie">
                            <PieChart :option="PieChartOption1" :pieID="3" :isreload='1'></PieChart>
                        </div>
                </div>
            </div>
            </div>
         </div>
                   <!-- 打开分类弹窗 -->
      <el-dialog
  title="请选择试题分类"
  :visible.sync="centerDialogVisible"
  width="40%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  @close="reback1(0)"
  v-if="centerDialogVisible"
  >
  <div class="forminfo"> 
     <topicClassTemplate 
     :authType='1'
    ref="topicClassTemplate"
     @sendStatus="classSelect"
    ></topicClassTemplate>
    <div class="authbtn flex align-cen">
        <el-button plain @click="reback1(0)"> 取消</el-button>
              <el-button type="primary" @click="onSubmit1">选择</el-button>
    </div>
  </div>
      </el-dialog>
      <!-- 打开编辑试题弹窗-->
      <el-dialog
      title="编辑试题"
  :visible.sync="centerDialogVisible1"
  width="60%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  @close="centerDialogVisible1 = false"
  v-if="centerDialogVisible1"
      >
      <div class="forminfo">
        <topicTemplate
            :topicID="PropId"
            :editId="editId"
            :paperId="$route.query.twoId"
            :editType="'paper'"
            ref="topicTemplate1"
             @custom-event="emitIsDlog"
            ></topicTemplate>
            <div class="authbtn flex align-cen">
        <el-button plain @click="cacelSub"> 取消</el-button>
              <el-button type="primary"  @click="editSubmit">确定</el-button>
    </div>
      </div>
      </el-dialog>
     </div>
</template>
<script>
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import {getPaper,randomPaper,getAllTopic,getAllTopicClassify,gettopicList,regularPaper,topicDelet,editPapeItem,duplicateList,updatePaperScore,countOfQuestionType,editPaperQuestion,analysisType,analysisTag,paperQuestionsSort} from "@/api/index/index"  //获取试卷详情、随机试题题组、根据查询题目列表、题目分类、固定试题卷组、删除试题、修改试卷、试题查重 、修改分数、随机组卷题型数、题型分析、难度分析
import topicClassTemplate from "@/views/testPaper/topicClass/index.vue"; //将题目分类页面作为组件使用
import topicTemplate from "@/views/testPaper/topicList/addTopic/index.vue"; //将新增题目页面作为组件使用
import PieChart from "../../../../components/pieTemolate/index.vue"; //饼图组件
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import importemplate from "@/views/testPaper/topicImport/index.vue"; //将导入页面页面作为组件使用
import twoImportemplate from "@/views/testPaper/topicImport/twoSteps/index.vue"; //将导入页面页面作为组件使用
import mycomponents from "../../../../utils/compoments.js";
import Sortable from "sortablejs";
export default {
    name:'twoIndex',
     components: {
        topicSteps,
        topicClassTemplate,
        topicTemplate,
        paginaTion,
        importemplate,
        twoImportemplate,
        PieChart,
        AudioTem: mycomponents.components.PublicAudio,

    },
    data() {
        return {
            txmodal:'',
            txtype:[
                {
                    name:'按问题分类',
                    value:'classify'
                },
                 {
                    name:'按相同题型',
                    value:'type'
                },
            ],
             // 八种漂亮的进度条颜色
            colors: [
                '#FF6B6B',  // 珊瑚红
                '#4ECDC4',  // 青绿色
                '#FFD166',  // 阳光黄
                '#06D6A0',  // 薄荷绿
                '#118AB2',  // 深海蓝
                '#EF476F',  // 玫红色
                '#7209B7',  // 紫色
                '#F15BB5'   // 粉色
            ],
             srdata:[],
             PieChartOption:{},
             PieChartOption1:{},
             sortable:null,
             oldIndex: null,
            newIndex: null,
            questionClassifyStr:'',
            questionType:{},
            isDlog:false,
            nullQueLen:false,
            commonIds:[],
            list:{},
            loading:false,
            loading1:false,
            editId:'',
            PropId:'',
            encryptQuery:'',
            isStep:true,
            importToticEmitArr:[],
            addToticEmitArr:[],
            errorDataChecked:[],
            regulaTypes:[
                {
                    value:1,
                    label:'单选题'
                },{
                    value:2,
                    label:'多选题'
                },{
                    value:3,
                    label:'判断题'
                },{
                    value:4,
                    label:'填空题'
                },{
                    value:5,
                    label:'问答题'
                },
                {
                    value:6,
                    label:'不定项选择题'
                },
                {
                    value:7,
                    label:'排序题'
                },
                {
                    value:9,
                    label:'完形填空题'
                }
            ],
            regulaTypesValue:[],
            regulaTag:['常识','较难','难','很难'],
            regulaTagValue:'',
            swichList:[],
            sortedIndexes:[],
            swichId:'',
            swichIndex:-1,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            textActive:-1,
            options:[],
            searchName:'',
             Eng:['A','B','C','D','E','F','G','H','I','J'],
            checkedTopic:[],
            checkedTopic1:[],
            checkAll:false,
            isIndeterminate: true,
             checkAll1:false,
            isIndeterminate1: true,
            multipleSelection1:[],
            TopicPage:[],
            allNum:0,
            checkTopicClass:false,
            isTopicList:false,
            selectList:[],
            centerDialogVisible:false,
            centerDialogVisible1:false,
            activeIndex:'1',
            isAddPaper:false,
            paperName:'',
            checkList:[],
            propList:[
            {
                steps:1,
                text:'基本信息',
            },
            {
                steps:2,
                text:'添加试题',
            },{
                steps:3,
                text:'试卷设置',
            },{
                steps:4,
                text:'完成', 
            }

        ]
        }
    },
    created () {
        this.getPaperDetail()
         this.getClass()
        this.getTopicPage()
        this.getAnalysisType()
        this.getAnalysisTag()
    },
    methods: {
        txSelect(){
            paperQuestionsSort({paperId:this.$route.query.twoId,sortBy:this.txmodal})
            .then(res =>{
                this.TopicPage = res.data
            })
        },
        // 难度分析
        getAnalysisTag(){
            analysisTag({paperId:this.$route.query.twoId})
            .then(res =>{
                let srdata = res.data.map(item => ({
                        value: Number(item.rate),
                        name: item.tag, // 根据你的工具方法
                        num: Number(item.num)
                        }));

                this.PieChartOption1 = {
                 tooltip: {
                  trigger: 'item',
                  formatter:function(params){
                    var str = '';
                     str = `${params.data.name}：${params.data.value}%`
                     return str
                  }
                },
                 series: [
                    {
                      name: '难度分析',
                      type: 'pie',
                      radius: '50%',
                      data: srdata,
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                      }
                    }
                  ]
                }
            })
        },
        // 试题分析
        getAnalysisType(){
            analysisType({paperId:this.$route.query.twoId})
            .then(res =>{
                let that = this
                this.srdata = res.data.map(item => ({
                        value: Number(item.rate),
                        name: this.$util.getTopicType(item.type), // 根据你的工具方法
                        num: Number(item.num)
                        }));

                this.PieChartOption = {
                 tooltip: {
                  trigger: 'item',
                  formatter:function(params){
                    var str = '';
                     str = `题型：${params.data.name}</br>占比：${params.data.value}%`
                     return str
                  }
                },
                 series: [
                    {
                      name: '题型分析',
                      type: 'pie',
                      radius: '50%',
                      data: this.srdata,
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                      }
                    }
                  ]
                }
            })
        },
                init(){
            let _this = this;
		  // 获取所有章节的容器
        const containers = document.querySelectorAll('.sortable-chapter');
        containers.forEach((container, chapterIndex) => {
            new Sortable(container, {
            handle: '.handle_move',
            draggable: '.childrenlist',
            animation: 150,
            onEnd(event) {
                _this.loading1 = true
                 let oldIndex = event.oldIndex;
                let newIndex = event.newIndex; 
                let params = {
                    id:_this.TopicPage[oldIndex].id,
                    sort:_this.TopicPage[newIndex].sort
                    }
                      editPaperQuestion(params,'put')
                        .then(res => {
                           if(res.code == 0){
                            _this.getTopicPage()
                            _this.loading1 = false
                           }else{
                            _this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                        })
               
	        },
            })
        })
			
		// 2. 创建并配置相关参数
		// this.sortable = new Sortable(el, {			

        //     handle:'.handle_move',

		// 	draggable:'.childrenlist', 	

		// })
	},
        // 批量修改分数
        ediScore(){
            let idArr = []
            for (const key in this.checkedTopic) {
             idArr.push(this.checkedTopic[key].id)
            }
            if(!idArr.length) return this.$util.Notifi('请选择需要修改分数的试题！','error','fa-exclamation-circle')
             this.$prompt(`您已勾选${idArr.length}道试题，批量修改分数为`, '修改分数', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^0\.\d{1,2}$|^0\.[1-9]\d$|^[1-9](\.\d{1,2})?$|^[1-9]\d(\.\d{1,2})?$|^100$|^100.0$|^100.00$/,
          inputErrorMessage: '请输入100以下的数字'
            }).then(({ value }) => {
            let params = {
                ids:idArr,
                paperId:this.$route.query.twoId,
                score:value
            }
            updatePaperScore(params)
            .then(res =>{
                if(res.code == 0){
                this.$util.Notifi('修改分数成功','success','fa-check')
                this.checkedTopic = []
                this.getTopicPage()
                }else{
                     this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                }
            })
            })
        },
        // 试题查重
        repeatPaper(){
           duplicateList({id:this.$route.query.twoId}) 
           .then(res =>{
            if(res.code == 0){
                if(res.data.ids.length){
                       for (const item1 of this.TopicPage) {  
                        if (res.data.ids.some(item2 => item2 == item1.id)) { 
                            this.$nextTick(() => {  
                                item1.classAdded = true; 
                            }) 
                        }else{
                           this.$nextTick(() => {  
                                item1.classAdded = false; 
                            }) 
                        }
                       }
                       this.$util.Notifi(`检测到有 ${res.data.duplicateNum} 道试题重复, 已为您标出多余的重复试题，请根据具体情况适当删除。`,'error','fa-exclamation-circle')  
                       this.$forceUpdate()
                       
                }else{
                this.$util.Notifi('没有检测到重复试题','error','fa-exclamation-circle')  
                }
            }else{
                this.$util.Notifi('查重失败！','error','fa-exclamation-circle')
            }
           })
        },
        // 删除试卷
        deletTopic(eventId,type){
            let idArr = []
           if(eventId==0){
            for (const key in this.checkedTopic) {
             idArr.push(this.checkedTopic[key].id)
            }
           }
          if(eventId==0 && !idArr.length) return this.$util.Notifi('请选择需要删除的试题！','error','fa-exclamation-circle')
          let tit = eventId==0 ? `您确定要删除已勾选的${idArr.length}道试题吗？` : '确定要删除该试题？删除后不可恢复！'
          let params = eventId==0 ? idArr.join(',') : eventId
        this.$confirm(tit, '温馨提示', 
        {
          confirmButtonText: '删除',
          cancelButtonText: '删除且从题库里也删除',
          type: 'warning',
          distinguishCancelAndClose:true
        },
        ).then(() => {
            this.commonDelet(params,'')
        })
        .catch(action =>{
            if(action == 'cancel'){
             this.commonDelet(params,1)
            }                   
        })
        },
        commonDelet(params,type){
             topicDelet({
              id:params,
              delQuestion:type || ''
              })
                .then(res => {
                if(res.code == 1) return this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                 if(res.code == 0){
                   this.$util.Notifi('删除成功','success','fa-check')
                   this.checkedTopic = []
                   this.getTopicPage()
                 }
              })
              .catch(err => {
                this.$util.Notifi('删除失败！','error','fa-exclamation-circle')
              })
        },
        // 打开试题编辑弹窗
        openEditTopic(data){
            this.PropId = data.questionId
            this.editId = data.id
            this.centerDialogVisible1 = true
        },
        // 取消
        cacelSub(){
            this.centerDialogVisible1 = false
            this.isDlog = false
        },
        emitIsDlog(val){
            this.isDlog = val
            if(this.isDlog){
                setTimeout(() => {
        this.centerDialogVisible1 = false 
        this.getTopicPage()
    }, 500);
}
        },
        // 试题编辑确定
        editSubmit(){
            this.$refs.topicTemplate1.onSubmit()  
        },
        // 添加试题
        addSt(){
         this.isTopicList = false
          this.checkTopicClass = true 
          if(this.activeIndex == 4){
            this.isStep = true
          }
        },
        // 添加试题切换
        handleTabStep(){
        //    this.isTopicList = false
        //   this.checkTopicClass = true
        },
        emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.checkAll1 = []
        this.getopicPage(this.swichId,this.swichIndex)
      },
    //   导入试题组件触发
    importToticEmit(data){
       this.isStep = false
       this.encryptQuery = data
    },
    // 导入试题第二步
    twoimportToticEmit(data){
        this.importToticEmitArr = data
         this.regulaSub(3)
    },
    // 导入第二部取消
    cacelIM(msg){
        this.isStep = true
    },
    //   添加试题子组件触发事件
    addToticEmit(id){
        this.addToticEmitArr = []
        this.addToticEmitArr.push(id)
        this.regulaSub(2)
    },
    //   手动选择确定操作
        regulaSub(type){
            if(!this.errorDataChecked.length && type == 1) {
                return this.$util.Notifi('请选择试题','error','fa-exclamation-circle')
            }else{
                this.errorDataChecked = this.errorDataChecked.filter(item => item !== undefined); 
            }
            let params = {
                questionIds: type == 1 ? this.errorDataChecked : type == 2 ? this.addToticEmitArr : type == 3 ? this.importToticEmitArr : [],
                paperId:this.$route.query.twoId
            }
           regularPaper(params)
           .then(res =>{
             if(res.code == 0){
                this.isTopicList = true
                this.checkTopicClass = false
                this.getTopicPage()
                this.getAnalysisType()
                this.getAnalysisTag()
              }else{
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle') 
              }
           })
           .catch(err =>{})
        },
    //   筛选切换
        swichTopic(id,index){
            this.currentPage = 1
            this.swichId = id
             this.swichIndex = index
             this.checkAll1 = []
             this.errorDataChecked = []
            this.getopicPage(id,index)
            
        },
        // 手动选择
        getopicPage(id,index){
            this.textActive = index
            let params = {
                id:'',
                title:'',
                createBy:'',
                tags:this.regulaTagValue,
                types:this.regulaTypesValue,
                classifyId:id,
                createTimeStart:'',
                createTimeEnd:'',
                size:this.PageSize,
                current:this.currentPage,
            }
               gettopicList(params)
                .then(res => {
                 this.swichList  = res.data.records
                this.totalCount = res.data.total
                })
          .catch(err => {})
        },
        // 获取题目分类
    getClass() {
      getAllTopicClassify({name:this.searchName})
        .then((res) => {
          this.options = res.data;
          this.getopicPage('',-1)
        })
        .catch((err) => {});
    },

        // 全选
        handleCheckAllChange(val){
             this.checkedTopic = val ? this.TopicPage : [];
             this.isIndeterminate = false;
        },
        // 全选记录翻页，保持选中状态
        handleCheckAllChange1(val){
             this.checkAll1 = val 
             if(this.checkAll1){
                this.swichList.forEach(item => {
                    this.errorDataChecked.push(item.id);
                    this.errorDataChecked = [...new Set(this.errorDataChecked)];
                })
             }else{
                this.swichList.forEach(item => {
                   let index = this.errorDataChecked.findIndex(list => {
                            return item.id == list;
                        })
                    if(index >= 0) {
                        this.errorDataChecked.splice(index, 1);
                    }
                })
             }
        },
        handleCheckedCitiesChange(value){
     let checkedCount = value.length;
        this.checkAll = checkedCount === this.TopicPage.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.TopicPage.length;
        },
        // 单选记录翻页，保持选中状态
        handleCheckedCitiesChange1(value){
           // errorDataChecked:保存选中的列表 
    let findIndex = this.errorDataChecked.findIndex(o => {
        return o === value.id;
    });

    if(findIndex != -1) {
        this.errorDataChecked.splice(findIndex, 1);
    } else { 
        this.errorDataChecked.push(value.id);
    }

    // 是否选中全选 
    var arr = JSON.parse(JSON.stringify(this.swichList))
    for(var i = arr.length - 1 ; i >= 0 ; i -- ){
        for(var j = 0 ; j < this.errorDataChecked.length ; j ++ ){
            if(arr[i].id == this.errorDataChecked[j]){
                arr.splice(i,1)
                break;
            }
        }
    }
    //         let checkedCount = value.length;
    // this.checkAll1 = checkedCount === this.swichList.length;
        },
         // 展开处理
        openTopicRe(isTrue,index,type,data){
            this.TopicPage[index].isTrue = !isTrue
             if(data.type == 7){
            // 创建一个包含原数组索引和值的数组  
                let indexedArray = data.answerList.map((item, index) => ({ item, index }));  
                // 根据sort值进行排序  
                indexedArray.sort((a, b) => a.item.sort - b.item.sort);      
                // 提取排序后的索引  
                this.sortedIndexes = indexedArray.map(item => item.index);  
                }
        },
        // 根据试卷ID查询题目列表
        getTopicPage(){
            getAllTopic({id:this.$route.query.twoId})
           .then(res =>{
               if(res.data){
                this.isTopicList = true
                this.nullQueLen = true
                this.checkTopicClass = false
                let arr = res.data
                
                    if(arr && arr.length){
                        arr.forEach(e => {
                        e['isTrue'] = false
                    });
                    }
               this.TopicPage = arr || []
                 this.$nextTick(() => {
                    this.init()
                })
               }else{
                this.TopicPage =  []
                this.isTopicList = false
                this.activeIndex = '1'
                this.selectList = []
                this.nullQueLen = false
               }

            })
        },
        // 随机试卷确定
        radomSub(){
            let paramsArr = []
               if(this.allNum <1){
                this.$util.Notifi(`抽选试题为0，请重新选择`,'error','fa-exclamation-circle')
                return
             }else{
                for (let i in this.questionType) {
                    if(this.questionType[i].subQuestionNum){
                        if(this.questionType[i].point){
                         paramsArr.push({
                            type:this.questionType[i].type,
                            questionNum:Number(this.questionType[i].subQuestionNum),
                            point:Number(this.questionType[i].point)
                        })
                        }else{
                             this.$util.Notifi(`请填写${this.$util.getTopicType(this.questionType[i].type)}分数`,'error','fa-exclamation-circle')
                             return
                        }
                    }
                }
             }
            if(paramsArr.length){
              let paramsData = {
                params:paramsArr,
                questionClassifyIds:this.questionClassifyStr,
                paperId:this.$route.query.twoId
            }
            randomPaper(paramsData)
            .then(res =>{
              if(res.code == 0){
                this.isTopicList = true
                this.checkTopicClass = false
                this.getTopicPage()
                 this.getAnalysisType()
                 this.getAnalysisTag()
              }else{
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
              }
            })
            .catch(err =>{})
            }
        },
        // 去除
        deletPro(data){
            let arr = []
            arr.push(data)
        let delet= this.selectList.filter(item=>!arr.some(ele=>ele.id===item.id)) 
         this.selectList = delet
         this.allNum = this.selectList.reduce((sum,item) => sum + Number(item.subQuestionNum),0)
        },
    // 计算总题数
    handleInputChange(index,type,data){
        if(type == 1){
          if(data.subQuestionNum > data.value || data.subQuestionNum <=0){
            data.subQuestionNum = 1
          }

        }
        // var reg = /^(1|([1-9]\d{0,1})|100)$/;
        // if(type == 1){
        //     if(reg.test(this.selectList[index].subQuestionNum)==false){
        //          this.$set(this.selectList[index], 'subQuestionNum', '')
        //     }
        //     console.log(this.selectList[index].subQuestionNum)
        // }
        // console.log(this.selectList[index].subQuestionNum)
        //    if(reg.test(this.selectList[index].subQuestionNum)==false || reg.test(this.selectList[index].point) == false){
        // type == 1 ? this.selectList[index].subQuestionNum = "" : this.selectList[index].point = '';
        // return false;
        // }
        // 对每项进行累加操作
        this.allNum = this.questionType.reduce((sum,item) => sum + Number(item.subQuestionNum),0)

    },
            // 表格选择
        classSelect(val,val1){
          
           this.selectList = val
        },
        // 取消弹窗列表
        reback1(type){
              this.$refs.topicClassTemplate.remove()
             this.centerDialogVisible = false  
        },
        // 选择弹窗
        onSubmit1(){
         if(!this.selectList.length) return this.$util.Notifi('请选择试题分类','error','fa-exclamation-circle')
         this.questionClassifyStr = this.selectList.map(item => item.id).join(',')
         let params = {
            questionClassifyId:this.questionClassifyStr,
            paperId:this.$route.query.twoId
         }
         countOfQuestionType(params)
         .then(res =>{
          if(res.code == 0){
            // 将对象转为数组
            let arr = Object.entries(res.data).map(([key, value]) => ({
                    type:key,
                    value:value,
                    subQuestionNum:'',
                    point:'',
                    }))
             this.questionType = arr
            

          }
            this.centerDialogVisible = false
            this.checkTopicClass = true
         })
        },
        // 打开题目分类选择弹框
        openTopicClass(){
            this.centerDialogVisible = true
            this.$nextTick(function () {   
                 this.$refs.topicClassTemplate.editfun(this.selectList)    
             })
        },
          // 获取试卷详情
        getPaperDetail(){
            getPaper({id:this.$route.query.twoId},'get')
            .then(res =>{
              this.list = res.data
              this.checkList = res.data.questionSet.split(',') || []
            })
            .catch(err =>{})
        },
        // 返回上一步
        reback(){
            this.$router.push({
            name:'addPaper',
            query:{
                id:this.$route.query.twoId
            }
            })
        },
        // 下一步
        openThree(){
                 if(this.TopicPage.length){
       this.loading = true
            this.list.questionSet = this.checkList.join(',')
             editPapeItem({...this.list,id:this.$route.query.twoId},'put')
                        .then(res => {
                             this.loading = false
                           if(res.code == 0){    
                                setTimeout(() => {
                           this.$router.push({
                            name:'threeIndex',
                            query:{
                                threeId:this.$route.query.twoId
                            }
                           })
                             }, 100);
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
            }else{
                this.$util.Notifi('请先添加试题','error','fa-exclamation-circle')
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.exam-pr-list{
    margin-top: 20px;
    margin-bottom: 20px;
    .bot-progess{
        width:230px;
        height: 10px;
        background: #ccc;
        .bot-progess-n{
            height: 10px;
        }
    }
}
.topicList-right{
    width: 300px;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    margin-top: 55px;
    padding: 15px 16px 20px;
        .addpaper{
    height: 32px;
    line-height: 30px;
    font-size: 14px;
    padding: 0 16px;
    border-radius: 2px;
    font-family: inherit;
    border-width: 1px;
    border-style: solid;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.3s;
    background: #155bd4;
    color: #fff;
    }
}
.topicList-left{
    width: calc(100% - 300px);
}
.publicViewClass{
    margin-bottom: 60px;
}
.edit-from-list{
    padding: 20px 0;
    .label{
        font-weight: bold;
    }
    .el-checkbox__label{
        font-weight: 400 !important;
    }
    .isRequild{
        position: relative;
    }
    .isRequild::before{
        content: '*';
        color: #f56c6c;
        position: absolute;
        left: -10px;
    }
    .addpaper{
    height: 32px;
    line-height: 30px;
    font-size: 14px;
    padding: 0 16px;
    border-radius: 2px;
    font-family: inherit;
    border-width: 1px;
    border-style: solid;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.3s;
    background: #155bd4;
    color: #fff;
    }
     .exam-pr-pie{
            height: 200px;
          }
}
.checkPaper4{
    background: #f7f8fa;
    padding-top: 5px;
}
.checkPaper{
    .f-h-flex2{
        height: 700px;
        display: flex;
        .categories-tree{
            height: inherit;
            width: 208px;
            overflow-y: auto;
            .tree-search{
                width: 90%;
                margin: 0 auto;
                position: relative;
                span{
                    position: absolute;
                    top: 50%;
                    right: 30px;
                    transform: translateY(-50%);
                    color: #999;
                }
            }
            .categories-tree-item{
                position: relative;
                padding: 0 10px;
               .jstree-node:first-of-type{
                margin-top: 30px;
               }
               .treeactive{
                background: #f5fbff!important;
                border-radius: 4px;
               }
                .jstree-node{
                    cursor: pointer;
                    margin-top: 10px;
                    padding-left: 30px;
                    height: 24px;
                    .jstree-icon{
                        display: block;
                       width: 24px;
                        height: 24px;
                        line-height: 24px; 
                        background: url('../../../../assets/images/tree-default.svg') no-repeat center;
                    }
                    span{
                        padding-left: 12px;
                        width: 100px;
                    }
                }

            }
        }
        .categories-panel-dragger{
            position: relative;
            flex-shrink: 0;
            width: 16px;
            height: 100% !important;
            border-right: 1px solid #e6e6e6;
            background-color: #f2f2f2!important;
        }
        .questions-panel{
            height: 100%;
            padding: 16px 0 0 0;
            position: relative;
            .grow-top{
                height: 50px;
                line-height: 50px;
                box-shadow: 0px 3px 6px 0px rgba(51, 51, 51, 0.1);
                margin-bottom: 16px;
                position: absolute;
                width: 100%;
                top: 0;
                left: 0;
                .fillter{
                  padding: 0 0px 0 20px;
                  .regulaOption{
                    width: 120px;
                  }
                }
            }
            .grow-cen-item{
                width: 100%;
                position: absolute;
                top: 60px;
                left: 0;
                height: calc(100% - 140px);
                overflow-y: auto;
                padding-left: 20px;
            }
             /*滚动条样式*/
        .grow-cen-item::-webkit-scrollbar,.categories-tree::-webkit-scrollbar{
            width: 4px;    
        }
        .grow-cen-item::-webkit-scrollbar-thumb,.categories-tree::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            background: rgba(0,0,0,0.2);
        }
        .grow-cen-item::-webkit-scrollbar-track,.categories-tree::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            border-radius: 0;
            background: rgba(255,255,255,0.1);

        }
            .grow-bot{
                box-sizing: border-box;
                justify-content: space-between;
                padding: 0 16px;
                height: 50px;
                line-height: 50px;

                .grow-bot-btn{
                    margin-top: 10px;
                    height: 32px;
                    line-height: 30px;
                    font-size: 14px;
                    padding: 0 16px;
                    border-radius: 2px;
                    font-family: inherit;
                    border-width: 1px;
                    border-style: solid;
                    text-align: center;
                    vertical-align: middle;
                    box-sizing: border-box;
                    cursor: pointer;
                    transition: all 0.3s;
                    background: #155bd4;
                    color: #fff;
                }
            }
        }
    }
    .tab-content{
        h4{
            font-size: 14px;
            font-weight: 400;
        }
        .qts-counts-tip{
            margin-top: 10px;
            .question-count{
                b{
                    color: #FF962A;
                }
            }
        }
        .at-sel-qs-cs-ls{
            margin: 24px 0 16px;
            .at-sel-qs-cs-ls-item{
                margin-bottom: 10px;
              .icon-delet{
                position: unset!important;
                font-size: 14px;
                margin-top: 0;
                margin-right: 12px;
                vertical-align: middle;
                cursor: pointer;
                color: #999;
              }
              .qts-cate-name{
                    min-width: 215px;
                cursor: pointer;
              }  
              .form-control{
                font-size: 14px;
                font-weight: normal;
                color: #333;
                background-color: #fff;
                border: 1px solid #e5e5e5;
                box-shadow: none;
                text-align: center;
                line-height: 1.5;
                padding: 5px 10px;
                border-radius: 3px;
                margin: 0 10px;
              }
            }
            .icon-folder{
                display: inline-block;
                text-align: center;
                margin-right: 0;
                background: url('../../../../assets/images/tree-default.svg') no-repeat center;
                    position: unset!important;
                    width: 20px!important;
                    height: 20px;
                    margin-top: 0;
                    vertical-align: middle;
                    cursor: pointer;
            }
        }
    }
    .no-category{
        text-align: center;
        padding: 50px 0;
        img{
            width: 120px;
        }
        .text{
           margin-bottom: 20px;
            width: 266px;
            text-align: center; 
            margin: 0 auto;
            font-size: 14px;
            span{
                color: #36aafd;
            }
        }
        .yks-blue{
            background-color: #155bd4;
            color: white;
            border: 1px solid #155bd4;
            padding: 7px 20px;
            border-radius: 4px!important;
            width: 100px;
            margin: 20px auto;
            cursor: pointer;
        }
    }
}
::v-deep{
     .clozeClass{
    p{
        display: inline-block !important;
      }
  }
    .regulaOption{
        margin-left: 20px;
                    .el-input__inner{
                        height: 34px !important;
                    }
    }
    .jiange{
        text-align: left !important;
        margin-top: 10px !important;
    }
    .topicList,.grow-cen-item{
        .topEditBtn{
            i{
                color: #999;
                padding-left: 20px;
                cursor: pointer;
            }
        }
        .el-checkbox-group{
                    .el-checkbox:hover{
            border: 1px solid #36aafd;
        }
        .commonClass{
            border: dashed 1px #eb0000!important;
            background-color:#fffafa!important
        }
       .el-checkbox{
            display: flex;
            padding: 24px 16px 20px;
            background-color: #ffffff;
            border-radius: 5px;
            border: solid 1px #e6e6e6;
            position: relative;
            margin-top: 16px;
            white-space: normal;
            margin-right: 15px;
            .el-checkbox__input{
                padding-top: 5px;
            }
            .el-checkbox__label{
                flex-grow: 1;
            }
            .handle_move{
                width: 60px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                font-size: 40px;
            }
            .topic-item{
                margin-left: 80px;
                .question-option-list{
                padding: 0 20px;
                margin-top: 30px;
                li{
                    list-style-type: upper-latin;
                    margin-bottom: 15px;
                    font-size: 14px;
                }
                li::marker{
                    unicode-bidi: isolate;
                font-variant-numeric: tabular-nums;
                text-transform: none;
                text-indent: 0px !important;
                text-align: start !important;
                text-align-last: start !important; 
                }
                .test_result{
                    margin-left: -20px;
                    .rightAnswer{
                        color: #36aafd;
                    }
                    .jx{
                        color: #999;
                        padding-top: 10px;
                    }
                }
            }
                .ques-title{
                    width: 100%;
                 .ques-number{
                    background-color: white;
                    color: #36aafd;
                    margin-right: 8px;
                    padding: 0px 12px;
                    border-radius: 4px!important;
                    font-size: 14px;
                    border: 1px solid #36aafd;
                     height: 20px;
                 }
                 .ques-type{
                    background-color: #36aafd;
                    padding: 2px 12px;
                    color: #fff;
                    border: none;
                    border-radius: 4px!important;
                    font-size: 12px;
                    margin-right: 20px;
                    width: 80px;
                     height: 20px;
                     text-align: center;
                 }   
                }
                .ques-answers{
                    padding-top: 15px;
                    .ques-answers-class{
                        height: 40px;
                        .label{
                            color: #999;
                            font-size: 14px;
                        }
                        .labels{
                            height: initial;
                            line-height: initial;
                            padding: 2px 12px;
                            font-size: 12px;
                            color: #999!important;
                            border-radius: 5px;
                            border: solid 1px #e6e6e6;
                            background-color: transparent!important;
                        }
                    }
                    .ques-answers-edit{
                        padding-top: 10px;
                        .edit-question{
                            padding: 0!important;
                        margin-right: 10px;
                        color: #4e6799;
                        cursor: pointer;
                        font-size: 14px;
                        }
                        .control-line{
                            display: inline-block;
                        vertical-align: middle;
                        width: 1px;
                        height: 16px;
                        background-color: #e6e6e6;
                        margin-right: 10px;
                        }
                    }
                }
            }
        }
        .el-checkbox:last-of-type{
            margin-right: 30px;
        } 
        }

    }
}
</style>